import type { ReactElement } from "react";

import managementTrackingService from "app/pages/sales-intelligence/modules/management/services/tracking/managementTrackingService";
import { resolveSignalsApiCustomAttributes } from "app/pages/sales-intelligence/modules/management/services/tracking/utils";
import { useSignalsApiStatusPollingQuery } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/query/queries/useSignalsApiStatusPollingQuery";
import { useTestWebhookSubscriptionMutation } from "app/pages/sales-intelligence/modules/signals-api-webhook/query/mutations/useTestWebhookSubscriptionMutation";
import type { IWebhookSubscriptionBaseModel } from "app/pages/sales-intelligence/modules/signals-api-webhook/types/row-data";

import WebhookTableForm from "../components/WebhookTableForm/WebhookTableForm";
import useGetWebhookSubscriptions from "../query/queries/useGetWebhookSubscriptions";

const SignalsApiWebhookContainer = (): ReactElement | null => {
    const { data } = useGetWebhookSubscriptions();
    const { mutate: testSubscription } = useTestWebhookSubscriptionMutation();
    const { data: signalApiData } = useSignalsApiStatusPollingQuery();

    const handleTest = ({ callbackUrl, signalsPerHook, signalTypes }: IWebhookSubscriptionBaseModel) => {
        managementTrackingService.trackSignalApiClickEvent(
            `test webhook/${decodeURI(callbackUrl)}`,
            resolveSignalsApiCustomAttributes(signalApiData),
        );
        testSubscription({
            callbackUrl,
            signalsPerHook,
            signalTypes,
        });
    };

    if (!data) {
        return null;
    }

    return (
        <WebhookTableForm
            subscriptions={data || []}
            onTest={handleTest}
        />
    );
};

export default SignalsApiWebhookContainer;
